// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager_bmqgr","avatar":"avatar_bdirt","avatarContainer":"avatarContainer_a08c5"};